import { render, staticRenderFns } from "./AggiungiAnagrafica.vue?vue&type=template&id=c5d3d7f8&"
import script from "./AggiungiAnagrafica.vue?vue&type=script&lang=js&"
export * from "./AggiungiAnagrafica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports